import React from "react";

const Check = ({ height = "22px", style, color = "#9E8C2F", viewBox = "0 0 22 22" }) => (
  <svg
    height={height}
    style={style}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.861 19.7364C15.7125 19.7364 19.6819 15.767 19.6819 10.9154C19.6819 6.06391 15.7125 2.09448 10.861 2.09448C6.00947 2.09448 2.04004 6.06391 2.04004 10.9154C2.04004 15.767 6.00947 19.7364 10.861 19.7364Z"
      stroke={color}
      strokeWidth="1.69362"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.11206 10.9155L9.60839 13.4118L14.6099 8.41919"
      stroke={color}
      strokeWidth="1.69362"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Check;
